"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CoreQuadOperation_1 = require("../../tree/core/CoreQuadOperation");
class C2dCoreQuadOperation extends CoreQuadOperation_1.CoreQuadOperation {
    get quadList() {
        return super.quadList;
    }
    getC2dShader() {
        return this.shader;
    }
    getRenderContext(index) {
        return this.quadList.getRenderContext(this.index + index);
    }
    getSimpleTc(index) {
        return this.quadList.getSimpleTc(this.index + index);
    }
    getWhite(index) {
        return this.quadList.getWhite(this.index + index);
    }
}
exports.C2dCoreQuadOperation = C2dCoreQuadOperation;
//# sourceMappingURL=C2dCoreQuadOperation.js.map